import msalInstance from "./msalInstance";
import { loginRequest } from "./authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export async function getApiToken() {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  try {
    const res = await msalInstance.acquireTokenSilent({ ...loginRequest, account });
    return res.accessToken;
  } catch (e) {
    const code = e?.errorCode;
    const needsInteraction =
      e instanceof InteractionRequiredAuthError ||
      code === "interaction_required" ||
      code === "consent_required" ||
      code === "login_required" ||
      code === "token_refresh_required";

    if (needsInteraction) {
      // This will navigate (redirect) and won’t return here immediately
      await msalInstance.acquireTokenRedirect({ ...loginRequest, account });
      return new Promise(() => {}); // keep caller pending until redirect completes
    }
    throw e; // surface unexpected errors
  }
}
